import {PayloadAction} from '@reduxjs/toolkit';
//types
import {IUserNotificationSettingReducer, IUserOrganizationSettingData} from '../../utils/types';

export const pendingOperation = (state: IUserNotificationSettingReducer) => {
	state.isLoading = true;
};

export const rejectedOperation = (state: IUserNotificationSettingReducer) => {
	state.isLoading = false;
};

export const getNotificationSetting = (
	state: IUserNotificationSettingReducer,
	{payload}: PayloadAction<IUserOrganizationSettingData>
) => {
	state.userSetting = payload;
	state.isLoading = false;
};

export const updateNotificationSetting = (
	state: IUserNotificationSettingReducer,
	{payload}: PayloadAction<IUserOrganizationSettingData>
) => {
	state.userSetting = payload;
	state.isLoading = false;
};
